"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Link = void 0;

var _index = require("../styles/index.js");

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);

    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }

    ownKeys.forEach(function (key) {
      _defineProperty(target, key, source[key]);
    });
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var Link = (0, _index.styled)('a', function (_ref) {
  var $theme = _ref.$theme;
  var colors = $theme.colors,
      typography = $theme.typography,
      animation = $theme.animation;
  return _objectSpread({
    color: colors.linkText
  }, typography.font450, {
    textDecoration: 'none',
    transitionProperty: 'color',
    transitionDuration: animation.timing100,
    transitionTimingFunction: animation.easeOutCurve,
    ':visited': {
      color: colors.linkVisited
    },
    ':hover': {
      color: colors.linkHover
    },
    ':active': {
      color: colors.linkActive
    }
  });
});
exports.Link = Link;
Link.displayName = "Link";